import Toast, { showToast } from './toast.component'
export default Toast
export { showToast }
